<script>
import ADuiTabOptions from '@dui/components/a-dui-tab-options/a-dui-tab-options.vue';

const BOOK_TYPE_OPTIONS = [
  {
    description: 'Standard fiction / non-fiction books. Can contain small illustrations.',
    image: require('@dui-assets/tab-option-text.svg'),
    title: 'Trade paperback / ebook',
    topOverride: '38px',
    value: 'default',
  },
  {
    description: `E.g: Children's picture books or cookbooks.`,
    image: require('@dui-assets/tab-option-illustrated.svg'),
    title: 'Illustrated book',
    topOverride: null,
    value: 'illustrated',
  },
];

export default {
  extends: ADuiTabOptions,
  data: () => ({
    vm: {
      options: BOOK_TYPE_OPTIONS,
    },
  }),
};
</script>
